import { useLanguage } from "../../LanguageContext";
import TimelineExperienceList from "../TimelineExperienceList";
import SectionTitle from "./SectionTitle";

export default function TimelineSection() {
	const { text } = useLanguage();

	return (
		<section className="home-section home-timeline-section">
			<SectionTitle
				id="timeline"
				kicker={text.timeline.kicker}
				title={text.timeline.title}
			/>
			<TimelineExperienceList experiences={text.timeline.experiences} />
		</section>
	);
}
